export default __webpack_public_path__ + "static/two-portraits-749e5c6287fcac712f03b6e2f3310fd0.png";